import { Action } from '@ngrx/store';
import { NewData } from '../models/new-data.model';

export enum NewDataActionTypes {
  NEWDATA_QUERY = '[NewData] Query',
  NEWDATA_LOADED = '[NewData] Fetched',

  NEWDATA_ADDED = '[NewData] Added',
  NEWDATA_EDITED = '[NewData] Edited',
  NEWDATA_DELETED = '[NewData] Deleted',
  NEWDATA_SAVED = '[NewData] Saved',
  NEWDATA_DELETEDALL = '[NewData] DeletedAll',

  NEWDATA_ERROR = '[NewData] Error'
}

export class NewDataQuery implements Action {
  readonly type = NewDataActionTypes.NEWDATA_QUERY;
}

export class NewDataLoaded implements Action {
  readonly type = NewDataActionTypes.NEWDATA_LOADED;

  constructor(public payload: { newdata: NewData[] }) {}
}

export class NewDataAdded implements Action {
  readonly type = NewDataActionTypes.NEWDATA_ADDED; 

  constructor(public payload: { newdata: NewData }) {}
}

export class NewDataEdited implements Action {
  readonly type = NewDataActionTypes.NEWDATA_EDITED;

  constructor(public payload: { newdata: NewData }) {}
}

export class NewDataSaved implements Action {
  readonly type = NewDataActionTypes.NEWDATA_SAVED;

  constructor(public payload: {newdata: NewData}) {}
}

export class NewDataDeleted implements Action {
  readonly type = NewDataActionTypes.NEWDATA_DELETED;

  constructor(public payload: { newdata: NewData }) {}
}

export class NewDataDeletedAll implements Action { 
  readonly type = NewDataActionTypes.NEWDATA_DELETEDALL;

  constructor(public payload: { newdata: NewData }) {}
}

export class NewDataError implements Action {
  readonly type = NewDataActionTypes.NEWDATA_ERROR;

  constructor(public payload: { error: any }) {}
}

export type NewDataActions =
  | NewDataQuery
  | NewDataLoaded
  | NewDataAdded
  | NewDataEdited
  | NewDataSaved
  | NewDataDeleted
  | NewDataDeletedAll
  | NewDataError;
